/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type IntentFilterConfigColumn = (typeof IntentFilterConfigColumn)[keyof typeof IntentFilterConfigColumn];

export const IntentFilterConfigColumn = {
  user_intent: 'user_intent',
} as const;
